export default __webpack_public_path__ + "bddf799373380d8b6c5235c0ca60a2b2.svg";